import React from "react";

import { DropdownValue } from "@/components/common/dropdown";
import { Icon, IconSizeEnum, IconTypeEnum } from "@/components/common/icon";

export const CONTACTS = {
  // todo: uncomment when WA is not blocked
  // wa: { title: `WhatsApp`, icon: `WhatsApp`, link: process.env.GATSBY_SUPPORT_WHATSAPP },
  tg: { title: `Telegram`, icon: IconTypeEnum.Tg, link: process.env.GATSBY_SUPPORT_TELEGRAM },
  mail: {
    title: process.env.GATSBY_SUPPORT_EMAIL,
    icon: IconTypeEnum.Email,
    link: process.env.GATSBY_SUPPORT_EMAIL,
  },
};

export const EXPERT_RATE_FOR_TEXTS = 70;

export const MIN_SESSION_DURATION = 10;

export const MINDBOX_DEVICE_ID = "mindboxDeviceUUID";
export const DEVICE_UUID = "deviceUUID";

/**
 * Брендовая превью-картинка сайта: og:image страниц без своей картинки и `WebSite.image` в JSON-LD.
 * Лежит в `static/`, поэтому отдаётся с домена сайта, а не из хранилища Strapi.
 */
export const DEFAULT_SOCIAL_IMAGE_PATH = "/images/og-default.jpg";

/** Размеры `og-default.jpg` — рекомендуемые для og:image. */
export const DEFAULT_SOCIAL_IMAGE_SIZE = { width: 1200, height: 630 };

/**
 * Путь логотипа со стабильным адресом (не меняется от сборки к сборке) — для JSON-LD
 * `Organization.logo` и внешних потребителей. Файл кладёт билд, копируя единственный
 * источник `src/images/logo_full.svg` (см. `gatsby-node.ts`), поэтому второй копии,
 * которая может разъехаться с оригиналом, в репозитории нет.
 * В интерфейсе логотип по-прежнему подключается импортом — там хэш в имени полезен.
 */
export const STABLE_LOGO_PATH = "/logo.svg";

/** Размеры `logo_full.svg` (нужны для `ImageObject` в JSON-LD). */
export const STABLE_LOGO_SIZE = { width: 3891, height: 1234 };

/**
 * Пояс для дат, которые попадают в статический HTML: страница рендерится и на сборке, и в браузере,
 * и с одним поясом дата в HTML совпадает с датой после гидрации.
 */
export const SITE_DATE_TIME_ZONE = "Europe/Moscow";

// Перенес значения платёжных опций в глобальный файл constants.tsx,
// так как в коде были дублирования для страницы записи на appointment и profile.

export const CLOUD_PAYMENT_CARD_VALUE: DropdownValue = {
  value: "-1",
  label: (
    <label className="payment-option">
      <Icon type={IconTypeEnum.ProtectedCard} size={IconSizeEnum.Size32} />
      <span>Российской картой (₽)</span>
    </label>
  ),
};

export const CLOUD_PAYMENT_FOREIGN_CARD_VALUE: DropdownValue = {
  value: "-2",
  label: (
    <label className="payment-option">
      <div className="payment-option__details">
        <Icon type={IconTypeEnum.ProtectedCard} size={IconSizeEnum.Size32} />
        <div className="payment-option__card-name-block">
          <span>Иностранной картой 1</span>
          <span className="payment-option__card-name">кроме Revolut</span>
        </div>
      </div>
    </label>
  ),
};

export const ROBOKASSA_PAYMENT_CARD_VALUE: DropdownValue = {
  value: "-3",
  label: (
    <label className="payment-option">
      <div className="payment-option__details">
        <Icon type={IconTypeEnum.ProtectedCard} size={IconSizeEnum.Size32} />
        <div className="payment-option__card-name-block">
          <span>Иностранной картой 2</span>
          {/* <span className="payment-option__card-name">для карт Revolut</span> */}
        </div>
      </div>
    </label>
  ),
};

export const ROBOKASSA_SBP_PAYMENT_CARD_VALUE: DropdownValue = {
  value: "-4",
  label: (
    <label className="payment-option">
      <Icon type={IconTypeEnum.SbpCard} size={IconSizeEnum.Size32} />
      <span>Система быстрых платежей</span>
    </label>
  ),
};

export const MAX_DIGITS_AMOUNT = 10;
export const PAYMENT_INITIAL_AMOUNT = 1000;

export const PRODUCT_CODE_KEY_FOR_URL_PARAMS_FIX_PAYMENT = "product-code";

// Image size constants
export const IMAGE_SIZES = {
  XS: 96,
  S: 288,
  M: 432,
  L: 648,
} as const;

export enum ErrorCodeEnum {
  StatusCodeInternalError = 1,
  StatusCodeAccessDenied = 3,
  StatusCodeBadRequest = 5,
  StatusCodeNotEnoughMoneyForSession = 7,
  StatusCodeNoSuchAccount = 21,
  StatusCodeWrongCredentials = 22,
  StatusCodeAuthMethodNotSupported = 23,
  StatusCodeInvalidPhone = 24,
  StatusCodeEmailNotVerified = 25,
  StatusCodeTooManyRequests = 26,
  StatusCodeEmailAlreadyUsed = 27,
  StatusCodePhoneNotSupported = 31,
  StatusCodeBlockedUsers = 32,
  StatusCodeReCaptchaError = 45,
  StatusCodePhoneAlreadyInUse = 51,
  StatusMagicLinkExpired = 61,
  StatusMagicLinkAlreadyUsed = 62,
  StatusAvitoExistingUserConflict = 63,
  NoAlternativeAuthorizationMethod = 70,
  errMaxCountOfUsersWithSuchIpExceeded = 80,
  StatusCodeExpertNotFound = 87,
  StatusCodeCommonAuthError = 20
}

// Landing Quiz constants
export const QUIZ_INFO_TEMPLATE_SERVICE_BADGES = [
  "Эксперты онлайн",
  "Конфиденциально",
  "Первый разговор бесплатно",
];

export const QUIZ_INFO_TEMPLATE_SERVICE_BADGES_STEP_2 = [
  "Прямо сейчас",
  "Можно без камеры",
  "Первый разговор бесплатно",
];
